import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { GalaxyApi } from "@/api";
import { useObjectStoreTemplatesStore } from "@/stores/objectStoreTemplatesStore";
import { rethrowSimple } from "@/utils/simple-error";
import InstanceDropdown from "@/components/ConfigTemplates/InstanceDropdown.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InstanceDropdown',
    props: {
        objectStore: null
    },
    emits: ["entryRemoved", "test"],
    setup(__props, { emit }) {
        const props = __props;
        const objectStoreTemplatesStore = useObjectStoreTemplatesStore();
        const routeEdit = computed(() => `/object_store_instances/${props.objectStore.uuid}/edit`);
        const routeUpgrade = computed(() => `/object_store_instances/${props.objectStore.uuid}/upgrade`);
        const isUpgradable = computed(() => objectStoreTemplatesStore.canUpgrade(props.objectStore.template_id, props.objectStore.template_version));
        async function onRemove() {
            const { error } = await GalaxyApi().PUT("/api/object_store_instances/{uuid}", {
                params: { path: { uuid: props.objectStore.uuid } },
                body: { hidden: true },
            });
            if (error) {
                rethrowSimple(error);
            }
            emit("entryRemoved");
        }
        return { __sfc: true, objectStoreTemplatesStore, props, routeEdit, routeUpgrade, isUpgradable, onRemove, emit, InstanceDropdown };
    }
});
